module.exports = __webpack_public_path__ + "img/project3.3df34d03.jpg";